export default __webpack_public_path__ + "static/media/img_9.bab4af96.jpg";